const getDomain = (rootState) => rootState.config.myyola.domain;

export default getDomain;
